import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import PDPInfoDimensionsSection from './PDPInfoDimensionsSection';
import PDPInfoDescriptionSection from './PDPInfoDescriptionSection';
import PDPInfoDetailsSection from './PDPInfoDetailsSection';
import PDPInfoCareSection from './PDPInfoCareSection';
export const PDP_INFO_DIMENSIONS_ID = 'pdp-info-dimensions';
export const PDP_INFO_DESCRIPTION_ID = 'pdp-info-description';
export const PDP_INFO_DETAILS_ID = 'pdp-info-details';
export const PDP_INFO_CARE_ID = 'pdp-info-care';

/**
 * The four product-info sections the layout revamp moves out of the rail, as
 * TabPanel items. A section whose data is missing drops out entirely, so a
 * product without care copy shows three tabs rather than an empty fourth.
 */
const usePDPInfoSections = t0 => {
  const $ = _c(16);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    stacked: t2
  } = t1;
  const stacked = t2 === undefined ? false : t2;
  const {
    data: t3
  } = useProductAttributes();
  const {
    dimensions,
    boxDimensions,
    description,
    additional_attributes: additionalAttributes,
    constructionDetails,
    productCareDetails,
    productPDF,
    assemblyDetailsPDF
  } = t3;
  const hasDescription = !!description || !!additionalAttributes?.showpiece_desc;
  const hasDimensions = !!dimensions?.length || !!boxDimensions?.length;
  const hasDetails = !!constructionDetails?.length || !!productPDF || !!assemblyDetailsPDF;
  productCareDetails?.length;
  let t4;
  if ($[2] !== hasDimensions || $[3] !== stacked) {
    t4 = hasDimensions && {
      id: PDP_INFO_DIMENSIONS_ID,
      label: "Product Dimensions",
      content: <PDPInfoDimensionsSection stacked={stacked} />
    };
    $[2] = hasDimensions;
    $[3] = stacked;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== hasDescription) {
    t5 = hasDescription && {
      id: PDP_INFO_DESCRIPTION_ID,
      label: "Product Description",
      content: <PDPInfoDescriptionSection />
    };
    $[5] = hasDescription;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== hasDetails) {
    t6 = hasDetails && {
      id: PDP_INFO_DETAILS_ID,
      label: "Product Details",
      content: <PDPInfoDetailsSection />
    };
    $[7] = hasDetails;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== productCareDetails?.length) {
    t7 = productCareDetails?.length && {
      id: PDP_INFO_CARE_ID,
      label: "Product Care",
      content: <PDPInfoCareSection />
    };
    $[9] = productCareDetails?.length;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = [t4, t5, t6, t7].filter(Boolean);
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default usePDPInfoSections;